const RequirementTypes = {
    WIND: 'WIND',
 //   COAL: 'COAL',
    SOLAR: 'SOLAR',
}

export default RequirementTypes;


/** WEBPACK FOOTER **
 ** ./src/redux/modules/requirements/RequirementTypes.js
 **/